/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class GroupDialog extends NoboxEntityDialog<GroupRow, any> {
        protected getFormKey() { return GroupForm.formKey; }
        protected getIdProperty() { return GroupRow.idProperty; }
        protected getLocalTextPrefix() { return GroupRow.localTextPrefix; }
        protected getService() { return GroupService.baseUrl; }
        protected getDeletePermission() { return GroupRow.deletePermission; }
        protected getInsertPermission() { return GroupRow.insertPermission; }
        protected getUpdatePermission() { return GroupRow.updatePermission; }

        protected form = new GroupForm(this.idPrefix);
        public isReadonly: boolean;

        constructor(container?: JQuery) {
            super(container);
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.isReadonly == true) {
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                this.element.find('sup').hide();
                this.saveAndCloseButton.remove();
                this.applyChangesButton.remove();
                this.deleteButton.remove();
                if (this.isEditMode()) {
                    var entityType = super.getEntitySingular();

                    // get name field value of record this dialog edits
                    let name = this.getEntityNameFieldValue() || "";

                    // you could use format with a local text, but again demo...
                    this.dialogTitle = 'View ' + entityType + " (" + name + ")";
                }
            }
        }
    }
}